import { Star } from 'lucide-react';

interface StarRatingProps {
  rating?: number;
  size?: number;
  color?: string;
}

const StarRating = ({ rating = 0, size, color = 'black' }: StarRatingProps) => {
  return (
    <div className="flex flex-row">
      {Array(5)
        .fill(null)
        .map((_, index) => (
          <Star
            key={index}
            size={size}
            fill={index < rating ? color : 'lightgray'}
            color={index < rating ? color : 'lightgray'}
          />
        ))}
    </div>
  );
};

export default StarRating;
